/* eslint-disabled */

export default class HandshakeExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
